import { FC } from 'react'

import Button, { ButtonProps } from '@mui/material/Button'
import { DGE_AUTH_METHOD, PLATFORM } from '@/constants/platform'

import { KeycloakIcon } from '../Icons'
import { useCredentials } from './useLogin/useCredentials'

type KeycloakButtonProps = ButtonProps

export const KeycloakButton: FC<KeycloakButtonProps> = (props) => {
  const { signIn } = useCredentials()

  return (
    <Button
      {...props}
      variant={'outlined'}
      color={'secondary'}
      startIcon={<KeycloakIcon />}
      onClick={() => signIn('', '', PLATFORM.DGE, DGE_AUTH_METHOD.KEYCLOAK)}
    >
      Login with Keycloak
    </Button>
  )
}
